import styles from './page.module.scss';
import React, {CSSProperties} from 'react';
import {classNames} from '../../support/classnames.ts';

interface OwnProps {
    children: React.ReactNode;
    style?: CSSProperties;
    isLoading?: boolean;
}

export function Page({children, style, isLoading}: OwnProps) {
    return (
        <div
            style={style}
            className={classNames(styles.page, {
                [styles.loading]: isLoading,
            })}
        >
            {children}
        </div>
    );
}
